/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export interface ChangeCompanyRequest {
    id: number;
    name?: string | undefined;
    status?: PortalStatus;
}

export interface ChangeUserRequest {
    id: number;
    firstName: string;
    lastName: string;
    companyIds?: number[] | undefined;
    combineCompanies?: boolean | undefined;
    companyDisplayName: string;
    language?: Locale;
    enabledGeneralNotification?: boolean | undefined;
    status?: PortalStatus;
}

export interface Company {
    id?: number;
    customerNr?: string | undefined;
    name?: string | undefined;
    createdDate?: Date;
    lastLoginDate?: Date | undefined;
    status?: PortalStatus;
}

export interface CompanyPagedResult {
    content?: Company[] | undefined;
    currentPage?: number;
    itemsPerPage?: number;
    totalItems?: number;
    readonly totalPages?: number;
}

export interface CreateCompanyRequest {
    companyName: string;
    customerNr: string;
}

export interface CreateUserRequest {
    firstName: string;
    lastName: string;
    userName: string;
    companyIds?: number[] | undefined;
    combineCompanies?: boolean;
    companyDisplayName: string;
    roleName?: UserRole;
    language?: Locale;
    enabledGeneralNotification?: boolean | undefined;
}

export interface Document {
    id?: number;
    documentType?: DocumentType;
    uploadDate?: Date;
    primaryValue?: string | undefined;
    secondaryValue?: string | undefined;
    customerNr?: string | undefined;
    fileName?: string | undefined;
}

export enum DocumentSearchType {
    None = "None",
    ArticleNr = "ArticleNr",
    ClientReference = "ClientReference",
    SalesOrder = "SalesOrder",
    SalesAgreement = "SalesAgreement",
    PackingSlip = "PackingSlip",
    BatchNr = "BatchNr",
    CertificateNr = "CertificateNr",
    InvoiceNr = "InvoiceNr",
}

export interface DocumentsGroup {
    group?: string | undefined;
    documents?: Document[] | undefined;
    count?: number;
}

export interface DocumentsGroupPagedResult {
    content?: DocumentsGroup[] | undefined;
    currentPage?: number;
    itemsPerPage?: number;
    totalItems?: number;
    readonly totalPages?: number;
}

export interface DocumentSummary {
    documentType?: DocumentType;
    count?: number;
}

export enum DocumentType {
    NotSet = "NotSet",
    SalesAgreements = "SalesAgreements",
    SalesOrders = "SalesOrders",
    PackingSlips = "PackingSlips",
    Certificates = "Certificates",
    Invoices = "Invoices",
}

export interface DocumentVersion {
    documentId?: number;
    versionDate?: Date;
}

export interface DownloadDocumentRequest {
    documentId: number;
    snapshotTime?: Date | undefined;
}

export interface ImpersonatableUser {
    id?: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleName?: string | undefined;
}

export interface ImpersonatableUsersRequest {
    companyId?: number;
}

export interface ImpersonateRequest {
    userId: number;
}

export enum Locale {
    EN = "EN",
    NL = "NL",
    DE = "DE",
    FR = "FR",
    UNKNOWN = "UNKNOWN",
}

export interface LoginRequest {
    email: string;
    password: string;
}

export interface NotificationSubscription {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    language?: Locale;
    type?: NotificationType;
}

export interface NotificationSubscriptionRequest {
    name: string;
    email: string;
    language: Locale;
    types: NotificationType[];
}

export enum NotificationType {
    NotSet = "NotSet",
    Invoices = "Invoices",
    SalesOrders = "SalesOrders",
    PackingSlips = "PackingSlips",
    SalesAgreements = "SalesAgreements",
}

export enum Permissions {
    NotSet = "NotSet",
    UserRead = "UserRead",
    UserChange = "UserChange",
    UserCreate = "UserCreate",
    CompaniesRead = "CompaniesRead",
    CompaniesChange = "CompaniesChange",
    CompaniesCreate = "CompaniesCreate",
    UserAdministratorRead = "UserAdministratorRead",
    UserAdministratorChange = "UserAdministratorChange",
    UserAdministratorCreate = "UserAdministratorCreate",
    UserManagerRead = "UserManagerRead",
    UserManagerChange = "UserManagerChange",
    UserManagerCreate = "UserManagerCreate",
    UserSupportRead = "UserSupportRead",
    UserSupportChange = "UserSupportChange",
    UserSupportCreate = "UserSupportCreate",
    Impersonate = "Impersonate",
    NotificationRead = "NotificationRead",
    NotificationChange = "NotificationChange",
    DashboardPageView = "DashboardPageView",
    ShipmentRequestPageView = "ShipmentRequestPageView",
    DocumentPageView = "DocumentPageView",
    UserManagementPageView = "UserManagementPageView",
    CompanyReadAny = "CompanyReadAny",
    CompanyChangeAny = "CompanyChangeAny",
    CompanyCreateAny = "CompanyCreateAny",
    UserReadAll = "UserReadAll",
    UserCreateAny = "UserCreateAny",
    UserChangeAny = "UserChangeAny",
    AccessAll = "AccessAll",
}

export enum PortalStatus {
    Inactive = "Inactive",
    Active = "Active",
}

export interface RequestPasswordRequest {
    email: string;
}

export interface ResetPasswordRequest {
    email: string;
    token: string;
    newPassword: string;
    repeatPassword: string;
}

export interface SetCompanyRequest {
    companyId: number;
}

export interface User {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    status?: PortalStatus;
    language?: Locale;
    enabledGeneralNotification?: boolean | undefined;
    isImpersonatedByUserName?: string | undefined;
    emailConfirmed?: boolean | undefined;
    companies?: Company[] | undefined;
    company?: Company;
    companyDisplayName?: string | undefined;
    combineCompanies?: boolean;
    readonly currentCompanies?: Company[] | undefined;
    readonly customerNrs?: string[] | undefined;
    readonly companyIds?: number[] | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    lastLoginDate?: Date | undefined;
    previousLastLoginDate?: Date | undefined;
    roleName?: UserRole;
    roles?: UserRole[] | undefined;
    token?: string | undefined;
    permissions?: Permissions[] | undefined;
    notificationSubscriptions?: NotificationSubscription[] | undefined;
    hasCertificates?: boolean;
    isImpersonatedOriginalRights?: boolean;
}

export interface UserPagedResult {
    content?: User[] | undefined;
    currentPage?: number;
    itemsPerPage?: number;
    totalItems?: number;
    readonly totalPages?: number;
}

export enum UserRole {
    SuperAdmin = "SuperAdmin",
    Administrator = "Administrator",
    Manager = "Manager",
    User = "User",
    Support = "Support",
    SupportWithOriginalRights = "SupportWithOriginalRights",
}